'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'file-invoice-dollar';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f571';
var svgPathData = 'M365.3 125.3l-106.5-106.5C246.7 6.742 230.5 0 213.5 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.35 28.65 64 64 64H320c35.35 0 64-28.65 64-64V170.5C384 153.5 377.3 137.3 365.3 125.3zM224 34.08c4.477 1.566 8.666 3.846 12.12 7.299l106.5 106.5C346.1 151.3 348.4 155.5 349.9 160H240C231.2 160 224 152.8 224 144V34.08zM352 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h128v112C192 170.5 213.5 192 240 192H352V448zM80 96h64C152.8 96 160 88.84 160 80S152.8 64 144 64h-64C71.16 64 64 71.16 64 80S71.16 96 80 96zM160 144C160 135.2 152.8 128 144 128h-64C71.16 128 64 135.2 64 144S71.16 160 80 160h64C152.8 160 160 152.8 160 144zM202 288.9c6.766 .9375 14.2 2.984 21.28 5.156c8.5 2.641 17.41-2.156 19.98-10.61c2.594-8.438-2.156-17.39-10.61-19.98c-10.03-3.078-17.96-4.947-24.99-6.008C207.8 256.1 208 256.5 208 256V240c0-8.844-7.133-16-15.98-16S176 231.2 176 240V256c0 .3008 .1543 .5488 .1699 .8457C150.6 260.1 132.9 273.3 128.9 294.1c-7.766 39.97 33.06 50.64 52.67 55.77l6.5 1.656c32.25 8.219 37.17 12.28 35.61 20.34c-1.844 9.453-19.78 14.34-41.81 11.22c-8.578-1.141-18.95-4.469-28.09-7.391l-4.969-1.594c-8.422-2.578-17.41 2.016-20.08 10.45c-2.656 8.438 2.031 17.42 10.45 20.08L144 406.1c10.05 3.221 21.38 6.756 32.3 8.359C176.3 415 176 415.5 176 416v16c0 8.844 7.18 16 16.02 16S208 440.8 208 432V416c0-.5078-.2422-.9375-.2891-1.434c25.42-3.33 43.36-15.98 47.38-36.63c7.859-40.41-32.45-50.67-59.13-57.45L189.7 318.9c-31.39-8.203-30.41-13.3-29.36-18.7C162.1 290.7 180.1 285.9 202 288.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileInvoiceDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;